import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-255" data-mp="3utm4aq96wfw5">
      <div className="mx-auto max-w-5xl" data-id="element-256" data-mp="cp0ykb16my7v">
        <div className="mx-auto max-w-2xl text-center" data-id="element-257" data-mp="cnzexi63p3ej">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-258" data-mp="7owk0qju4dka">
            6 Core Teaching Volumes for the Art Year
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-259" data-mp="3g2vchi7llgt1">
            A connected sequence of visual resources that moves from foundational concepts to
            drawing, color, design, visual culture and independent creative work.
          </p>
        </div>
        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-260" data-mp="3l2rh9jo4dc9n">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-gold/35 bg-navy-mid p-5 shadow-sm shadow-black/25 sm:gap-6 sm:p-7" data-id="element-261" data-mp="2xcx7jaz3k3tm" data-mpi={index}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-262" data-mp="2o4wpq6c72vms">
                <span className="font-display text-3xl font-bold leading-none text-gold sm:text-4xl" data-id="element-263" data-mp="2o67r5zi63raq">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-264" data-mp="1vgin1da5vb4w">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/70" data-id="element-265" data-mp="24gfibxr2388x">
                  {volume.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-gold/15 px-3 py-1 text-xs font-medium text-gold" data-id="element-266" data-mp="3bsxquu71n9s6">
                  {volume.tag}
                </span>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-navy p-1.5 ring-1 ring-gold/30" data-id="element-267" data-mp="1gq1aqb9edelb">
                <img src={volume.coverImage} alt={`Cover of volume ${volume.number}: ${volume.title}`} width="108" height="162" loading="lazy" decoding="async" className="block h-[132px] w-[88px] rounded-lg object-cover shadow-[0_8px_16px_-7px_rgba(0,0,0,0.65)] sm:h-[162px] sm:w-[108px]" data-id="element-268" data-mp="1bsj4wtqoffhj" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}